import { useMainStore } from "../../../main/store/mainStore.js";
import { maxQueueLength } from "./data/log-queue-config.js";
import { queue } from "./queue.js";

export const enqueue = (entry) => {
  if (queue.length >= maxQueueLength) {
    queue.shift();

    useMainStore().logEntryWriteFailureCount += 1;
  }

  queue.push({ ...entry, attempts: 0 });
};
